import { render, staticRenderFns } from "./PrescriptionAudit.vue?vue&type=template&id=1b16fede&scoped=true&"
import script from "./PrescriptionAudit.vue?vue&type=script&lang=js&"
export * from "./PrescriptionAudit.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionAudit.vue?vue&type=style&index=0&id=1b16fede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b16fede",
  null
  
)

export default component.exports